import { message } from 'antd';
import { putWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const updateDay = async (data: any, refetch?: () => void) => {
  console.log('Updating day with: ', data);
  try {
    const response = await putWithCSRF(`${envApiUrl}/registrations/`, data);
    message.success('Successfully updated registration');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('updateDay error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to update registration');
  }
};
